import React from 'react';
import ReservePlaceButton from '../../components/marketing/ReservePlaceButton';
import { HEALTH_CHECK_COPY, HEALTH_CHECK_SUMMARY } from '../content/healthCheck';
import { WAITLIST_DEPOSIT } from '../content/waitlist';
import Button from '../primitives/Button';
import { summarise, type Answers } from './healthCheckMachine';

interface HealthCheckSummaryProps {
  answers: Answers;
  /** The waitlist entry just created; the deposit step is offered against it. */
  entryRef: string | null;
  onClose: () => void;
}

/**
 * The non-clinical reading of how the person's health is being looked after.
 * No score is shown; the band picks a sentence and that is all.
 */
export default function HealthCheckSummary({ answers, entryRef, onClose }: HealthCheckSummaryProps) {
  const { band } = summarise(answers);
  const summary = HEALTH_CHECK_SUMMARY[band];
  return (
    <>
      <p className="t-details">{HEALTH_CHECK_COPY.panelTitle}</p>
      <h2 className="mk-hc-panel__question">{summary.title}</h2>
      <p className="mk-hc-panel__hint t-body">{summary.body}</p>
      {entryRef ? (
        <div className="wl-pay mk-hc-panel__pay">
          <p className="t-details">{WAITLIST_DEPOSIT.heading}</p>
          <p className="mk-hc-panel__hint t-body">{WAITLIST_DEPOSIT.terms}</p>
          <ReservePlaceButton entryRef={entryRef} />
          <p className="t-details t-muted">{WAITLIST_DEPOSIT.processing}</p>
        </div>
      ) : (
        <p className="mk-hc-panel__hint t-body">{HEALTH_CHECK_COPY.doneNote}</p>
      )}
      <div className="mk-hc-actions" style={{ justifyContent: 'center' }}>
        <Button variant="link" onClick={onClose}>
          Close
        </Button>
      </div>
    </>
  );
}
